import en from "./messages/en.json";
import fi from "./messages/fi.json";
import se from "./messages/se.json";

export default {
  en,
  fi,
  se
};



// WEBPACK FOOTER //
// ./src/static/messages.js